var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtlas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#31FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.7657L7.59375 11.988H10.4062L9 14.7657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 7.17075L6.48558 12.51C6.40233 12.681 6.35902 12.8194 6.17621 12.8194L4.51515 12.8205C4.27721 12.8205 4.14558 12.7592 4.26146 12.5111L8.32271 3.76706C8.40652 3.6225 8.45827 3.51562 8.64108 3.51562H9.35996C9.54277 3.51562 9.59452 3.6225 9.67777 3.76763L13.739 12.5111C13.8549 12.7597 13.7233 12.8211 13.4853 12.8211L11.8243 12.8205C11.6415 12.8205 11.5981 12.6816 11.5149 12.5106L8.99996 7.17075Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlas);
export default __webpack_public_path__ + "static/media/atlas.82e8614a9fca21a27d8099884a108127.svg";
export { ForwardRef as ReactComponent };